<template lang="pug">
	.agreements
		article.agreement
			.content
				.fields
					.row
						div
							.form-col.large-12
								validation-provider(v-slot="{ errors }" :rules="{required: true}")
									.field.checkbox-field2
										label(:class="{error: errors[0] || (!transferAgreements.accepted && acceptedTouched)}")
											input.no-custom(type="checkbox" v-model="transferAgreements.accepted" id="transfer-accepted-input" @blur="acceptedTouched = true")
											span.label-text
												| {{t('app.registration.agreements_agree')}}
												span.required *
							.form-col.large-6
								label.inline.right
									| {{t('app.registration.agreements_field_name')}}
									span.required *
							.form-col.large-6
								validation-provider(v-slot="{ errors }" :rules="{required: true}")
									.field
										.input__container
											label(:class="{error: errors[0] || (!transferAgreements.first_name && firstNameTouched)}")
												span.float-placeholder.active.required
													span.required *
													| {{ t('app.registration.agreements_name') }}
												input(type="text" :placeholder="t('app.registration.agreements_name')", v-model="transferAgreements.first_name" id="transfer-firstname-input" @blur="firstNameTouched = true")
												label
													span.label-text
														| {{t('app.registration.transfer_request.agreement_statement')}}
							.form-col.large-24
								p.small.agreements_agreement
									| {{t('app.registration.agreements_agreement')}}
</template>

<script>
	export default {
		props:{
			transferAgreements: {
				type: Object,
				default(){
					return {}
				},
			},
		},
	}
	methods: {

	}
	
</script>									
					